import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { DataGridTable, ListContainer, ListContext } from '../../../ui';
import { FC, useContext } from 'react';
import { getFunctionalDynamicAssessmentList } from '../../network';
import { TRowClickFunction } from '../../../ui/components/DataGridPro/helpers';
import { styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FDAListItem } from '../../types';
import { Card } from '../../../ui';
import { format } from 'date-fns';
import { ScanStatusChip } from '../../../scan/ui/ScanStatusChips';

type FDADashboardTableProps = {
  patientView: boolean;
  patient?: number;
};

export const FDADashboardTable: FC<FDADashboardTableProps> = ({
  patientView,
  patient,
}) => {
  const filters = useMemo(
    () => ({
      patient,
    }),
    [patient]
  );
  const content = (
    <ListContainer
      dataRequest={getFunctionalDynamicAssessmentList}
      filters={filters}
    >
      <FunctionalDynamicAssessmentTable patient={patient} />
    </ListContainer>
  );

  return patientView ? (
    <Card title='Functional Dynamic Assessments (Beta)'>{content}</Card>
  ) : (
    <div style={{ marginTop: '2vh' }}>
      <Header>
        <Typography variant='h2'>
          Functional Dynamic Assessments (Beta)
        </Typography>
      </Header>
      {content}
    </div>
  );
};

const Header = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

const StatusText = styled(Typography)`
  font-weight: bold;
  margin-left: 3%;
`;

type FunctionalDynamicAssessmentTableProps = {
  patient?: number | null;
};

const FunctionalDynamicAssessmentTable: FC<
  FunctionalDynamicAssessmentTableProps
> = ({ patient = null }) => {
  const { data, loading } = useContext(ListContext);
  const navigate = useNavigate();

  const onRowClick: TRowClickFunction<any> = (item: FDAListItem) => {
    navigate(
      `/patients/${item.patient}/functional-dynamic-assessment?fdaId=${item.id}`
    );
  };

  const columns: GridColDef[] = [
    ...(!patient
      ? []
      : [
          {
            field: 'id',
            headerName: 'ID',
            minWidth: 50,
            flex: 1,
          },
        ]),
    ...(patient
      ? []
      : [
          {
            field: 'first_name',
            headerName: 'First Name',
            minWidth: 100,
            flex: 1,
          },
          {
            field: 'last_name',
            headerName: 'Last Name',
            minWidth: 100,
            flex: 1,
          },
        ]),
    {
      field: 'status',
      width: 150,
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        const row = params.row as FDAListItem;
        return <ScanStatusChip status={row.status} />;
      },
    },
    {
      field: 'created_at',
      width: 150,
      headerName: 'Scan Date',
      valueFormatter: (params) => {
        return format(new Date(params.value as string), 'yyyy-MM-dd');
      },
      flex: 1,
    },
  ];

  return (
    <div>
      <DataGridTable
        loading={loading}
        data={data}
        columns={columns}
        tableType='functional_analysis'
        onRowClick={onRowClick}
      />
    </div>
  );
};
